














































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { parseToNumber, valueOrEmpty } from "@/utils/number";
import * as _ from "lodash";
import { isProductLevelCharacteristic } from "@/utils/characteristic-data-type";
import CharacteristicsTable from "@/components/reports/partials/show/characteristics-table.component.vue";
import EditMeasurements from "@/components/reports/partials/show/edit/edit-measurements.vue";
import Subheader from "@/components/reports/partials/show/subheader.vue";
import { EditSheetCharacteristics } from "@/components/reports/partials/show/edit/types/edit-measurements-characteristic";
import { saveMeasurementsVariables } from "@/models/mutations/types/saveMeasurements";
import { NewReportStore } from "@/store/NewReportStore";
import EditReportSheetInfo from "@/components/reports/partials/show/edit/edit-report-sheet-info.vue";
import EditWoodInfo from "@/components/reports/partials/show/edit/edit-wood-info.vue";
import WoodInfo from "@/components/reports/partials/show/wood-info.vue";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import AttachmentCards from "@/components/reports/partials/attachment-cards.vue";
import { Watch } from "vue-property-decorator";
import { ReportStep, SetReportDateType, WoodInfoInput } from "@/models/graphql-global-types";
import { openFile } from "@/utils/open-file";
import { InputDirection } from "@/models/input-direction";
import PrintReportDialog from "@/components/reports/partials/print-report-dialog.vue";

@Component({
  props: {
    reportSheet: {},
    canDelete: Boolean,
    deletingAttachments: Array,
    showDeleteConfirmation: Function,
    openImage: Function,
    uploadFile: Function,
    refetchReport: Function,
    isUserReportOwner: Boolean,
    reportId: String,
    canEditReport: Boolean,
    canUploadAttachments: Boolean,
    reportStep: String,
    onPrintReportSheet: Function,
  },
  components: {
    WoodInfo,
    EditWoodInfo,
    EditReportSheetInfo,
    Subheader,
    CharacteristicsTable,
    EditMeasurements,
    AttachmentCards,
    ClipLoader,
    PrintReportDialog,
  },
})
export default class SheetView extends Vue {
  private sheetInfoExpanded = false;
  private reportSheet!: any;
  private isUserReportOwner!: boolean;
  private reportId!: string;
  private reportStep!: ReportStep;
  private woodInfoExpanded: boolean = false;

  private characteristicsToEdit: EditSheetCharacteristics[] | null = null;
  private isSavingMeasurements: boolean = false;
  private isSavingAndMeasurementsDone: boolean = false;

  private sheetToEdit: any = null;
  private isSavingSheetInfo: boolean = false;

  private woodInfoToEdit: EditWoodInfo | null = null;
  private isSavingWoodInfo: boolean = false;

  private attachmentsExpanded = false;

  private refetchReport!: () => Promise<void>;

  private characteristicLevelCharacteristics: any[] = [];
  private productLevelCharacteristics: any[] = [];

  private inputDirection: InputDirection = InputDirection.HORIZONTAL;

  private formatUnit(unit) {
    return unit.replace("Degrees", "°").replace("Degree", "°");
  }

  private showValueOrEmpty(val: any) {
    return valueOrEmpty(val);
  }

  private showError(value: any, min: any, max: any) {
    const minValue = parseToNumber(min);
    const maxValue = parseToNumber(max);

    if (value && minValue && maxValue) {
      const num = parseToNumber(value);

      return num && (num < minValue || num > maxValue);
    } else if (value && valueOrEmpty(value) === "nok") {
      return true;
    }

    return false;
  }

  private round(val: number) {
    const v = val ? _.round(val, 2) : "";
    return valueOrEmpty(`${v}`, true);
  }

  private onOpenTechnicalDrawing() {
    openFile(this.reportSheet.product.technicalDrawing, this.$router);
  }

  get productDescription() {
    if (this.isUserReportOwner) {
      return this.reportSheet.product.description;
    }

    return this.reportSheet.product.customerProductDescription || this.reportSheet.product.description;
  }

  get articleNumber() {
    if (this.isUserReportOwner) {
      return this.reportSheet.product.articleNumber;
    }

    return this.reportSheet.product.customerArticleNumber || this.reportSheet.product.articleNumber;
  }

  public onEditMeasurements() {
    const prepared = this.reportSheet.characteristics.map((c) => {
      const measurements = c.measurements?.map((m) => {
        return {
          value: valueOrEmpty(m.value, true),
        };
      });
      return {
        ...c,
        measurements: (measurements?.length ?? 0) > 0 ? measurements : _.times(10, () => ({ value: null })),
      };
    });

    this.characteristicsToEdit = _.sortBy(prepared, ["sortGroup", "order"]);
  }

  public async onSaveMeasurements(shouldSetFinishTimestamp: boolean): Promise<boolean> {
    try {
      const data: saveMeasurementsVariables = {
        reportId: this.reportId,
        sheetId: this.reportSheet.id,
        productId: this.reportSheet.product.id,
        measurements:
          this.characteristicsToEdit?.map((ch) => ({
            characteristicsId: ch.id,
            shortcut: ch.shortcut ?? "",
            values: ch.measurements?.map((m) => m.value) ?? [],
          })) ?? [],
      };

      this.isSavingMeasurements = !shouldSetFinishTimestamp;
      this.isSavingAndMeasurementsDone = shouldSetFinishTimestamp;

      await NewReportStore.saveMeasurements(data);

      if (this.reportStep === ReportStep.CREATED) {
        await NewReportStore.changeStatus({ report: { id: this.reportId }, lane: ReportStep.IN_PROGRESS });
      }

      if (shouldSetFinishTimestamp) {
        await NewReportStore.setReportDate({
          reportId: this.reportId,
          sheetId: this.reportSheet.id,
          type: SetReportDateType.DATA_ENTRY_END,
        });
      } else {
        await NewReportStore.setReportDate({
          reportId: this.reportId,
          sheetId: this.reportSheet.id,
          type: SetReportDateType.DATA_ENTRY_START,
        });
      }

      await this.refetchReport();
      this.showSuccess("general.success", "report.success.measurements.message");
      this.isSavingMeasurements = false;
      this.isSavingAndMeasurementsDone = false;
      this.reportSheet.characteristics = this.characteristicsToEdit;
      this.characteristicsToEdit = null;
      return true;
    } catch (e) {
      this.isSavingMeasurements = false;
      this.isSavingAndMeasurementsDone = false;
      this.showGenericError();
      return false;
    }
  }

  public onEditSheetInfo() {
    this.sheetInfoExpanded = true;
    this.sheetToEdit = Object.assign({}, this.reportSheet);
  }

  public onSaveSheetInfo() {
    return new Promise<boolean>((resolve, reject) => {
      this.isSavingSheetInfo = true;
      NewReportStore.saveReportSheetInfo({
        reportId: this.reportId,
        sheetId: this.sheetToEdit.id,
        properties: {
          materialCertificate: this.sheetToEdit.material_certificate,
          heatNr: this.sheetToEdit.heat_nr,
          batch: this.sheetToEdit.charge,
          orderQuantity: parseToNumber(this.sheetToEdit.orderQuantity),
        },
      })
        .then((result) => {
          this.showSuccess("general.success", "report.success.sheet_info.message");
          this.isSavingSheetInfo = false;
          this.reportSheet = Object.assign({}, this.sheetToEdit);
          this.sheetToEdit = null;
          resolve(true);
        })
        .catch((_) => {
          reject();
          this.showGenericError();
        });
    });
  }

  public editWoodInfo() {
    this.woodInfoExpanded = true;
    this.woodInfoToEdit = Object.assign({}, this.reportSheet.info);
    //@ts-ignore
    delete this.woodInfoToEdit?.__typename;
  }

  public async onSaveWoodInfo() {
    if (this.woodInfoToEdit) {
      try {
        await NewReportStore.saveWoodInfo({
          reportId: this.reportId,
          sheetId: this.reportSheet.id,
          woodInfo: this.woodInfoToEdit as WoodInfoInput,
        });
        await this.refetchReport();
        this.showSuccess("general.success", "report.success.wood_info.message");
        this.isSavingWoodInfo = false;
        this.reportSheet.info = Object.assign({}, this.woodInfoToEdit);
        this.woodInfoToEdit = null;
        return true;
      } catch (e) {
        this.showGenericError();
        return false;
      }
    }
  }

  private cancelEditingMeasurements() {
    this.characteristicsToEdit = null;
  }

  private cancelEditingSheetInfo() {
    this.sheetToEdit = null;
  }

  private cancelEditingWoodInfo() {
    this.woodInfoToEdit = null;
  }

  private showGenericError() {
    this.$notify({
      title: this.$t("general.error.title") as string,
      text: this.$t("general.error.generic_error") as string,
      type: "error",
    });
  }

  private showSuccess(titleKey: string | null, messageKey: string) {
    this.$notify({
      title: titleKey ? (this.$t(titleKey) as string) : undefined,
      text: this.$t(messageKey) as string,
      type: "success",
    });
  }

  private getCharacteristicLevelCharacteristics() {
    const filtered = this.reportSheet.characteristics.filter((c) => !isProductLevelCharacteristic(c.dataType));

    return _.sortBy(filtered, ["sortGroup", "order"]);
  }

  private getProductLevelCharacteristics() {
    const filtered = this.reportSheet.characteristics.filter((c) => isProductLevelCharacteristic(c.dataType));

    return _.sortBy(filtered, ["sortGroup", "order"]);
  }

  @Watch("reportSheet")
  public onSheetChanged(newSheet: any, oldSheet: any) {
    this.characteristicLevelCharacteristics = this.getCharacteristicLevelCharacteristics();
    this.productLevelCharacteristics = this.getProductLevelCharacteristics();
    if (newSheet?.id !== oldSheet?.id) {
      this.cancelEditingWoodInfo();
      this.cancelEditingMeasurements();
      this.cancelEditingSheetInfo();
    }
  }

  public mounted() {
    this.characteristicLevelCharacteristics = this.getCharacteristicLevelCharacteristics();
    this.productLevelCharacteristics = this.getProductLevelCharacteristics();
  }

  get inputDirectionIcon(): string {
    switch (this.inputDirection) {
      case InputDirection.HORIZONTAL:
        return "svg/direction_horizontal.svg";
      case InputDirection.VERTICAL:
        return "svg/direction_vertical.svg";
    }
  }

  public changeInputDirection() {
    switch (this.inputDirection) {
      case InputDirection.VERTICAL:
        this.inputDirection = InputDirection.HORIZONTAL;
        break;
      case InputDirection.HORIZONTAL:
        this.inputDirection = InputDirection.VERTICAL;
        break;
    }
  }
}
